import React from 'react';
import { styled } from '@components-shared/src/stitches';
import { WebWorkerImage } from '@components/basics/Images/WebWorkerImage';
import { NextFutureImage } from '@components/main-components/image/NextFutureImage';
import { blurImage } from '@components/main-components/image/blur-image';
import { ImageViewModal } from '@components/modals/ImageViewModal';
import { MediaQuery } from '@context/mediaQuery';
import { ModalContext, ModalType } from '@context/modal';

export const SongCoverImage = ({
  songTitle,
  coverImage,
  size,
  hasCountdown = false,
  isAnimated = false,
  showGoldenEggToggle = false,
}: {
  songTitle: string;
  coverImage: string;
  size: number;
  hasCountdown?: boolean;
  isAnimated?: boolean;
  showGoldenEggToggle?: boolean;
}) => {
  const { tablet } = MediaQuery.useContainer();
  const { openModal } = ModalContext.useContainer();

  const coverBorderRadius = tablet ? 14 : 8;

  const onClick = () => {
    openModal(ModalType.IMAGE_VIEW, {
      body: <ImageViewModal src={coverImage} />,
    });
  };
  return (
    <Container>
      {isAnimated ? (
        <WebWorkerImage
          src={coverImage}
          width={size}
          height={size}
          style={{
            borderRadius: coverBorderRadius,
          }}
          onClick={showGoldenEggToggle ? undefined : onClick}
        />
      ) : (
        <NextFutureImage
          alt={songTitle}
          src={coverImage}
          width={size}
          height={size}
          placeholder="blur"
          blurDataURL={blurImage(size, size)}
          style={{
            borderRadius: coverBorderRadius,
            objectFit: 'cover',
            objectPosition: 'center',
          }}
          onClick={showGoldenEggToggle ? undefined : onClick}
          priority
        />
      )}
      {hasCountdown && <Overlay />}
    </Container>
  );
};

const Container = styled('div', {
  display: 'flex',
  position: 'relative',
  overflow: 'hidden',
  borderRadius: 8,
  marginTop: 0,
  height: 'fit-content',
  '&:hover': {
    cursor: 'pointer',
  },
});

const Overlay = styled('div', {
  position: 'absolute',
  left: 0,
  right: 0,
  top: 0,
  bottom: 0,
  backgroundColor: 'rgba(0,0,0,0.7)',
  '@tablet': {
    display: 'none',
  },
});
